import {
  DistrictEntity,
  ProvinceEntity,
  ZoneEntity,
} from "@features/country/domain";
import { DistrictModel } from "../models/district.model";
import { ProvinceWithZoneAndDistrictsModel } from "../models/province.model";
import { ZoneModel } from "../models/zone.model";

export function mapProvinceWithZoneDistricts(
  province: ProvinceWithZoneAndDistrictsModel,
): ProvinceEntity {
  return {
    id: province.provinceId,
    name: province.provinceName,
    shippingCost: province.shippingRevenue,
    zones: province.zones?.map(mapZone),
  };
}

function mapZone(zone: ZoneModel): ZoneEntity {
  return {
    id: zone.zoneId,
    name: zone.zoneName,
    districts: zone.districts?.map(mapDistrict),
  };
}

function mapDistrict(district: DistrictModel): DistrictEntity {
  return {
    id: district.districtId,
    name: district.districtName,
  };
}
